<template>
  <div>
    <card
      class="custom-shadow-card-header"
    >
    <div class="dashboard-title">
      <strong>
        {{ $t('grow.security_report') }}
      </strong>
    </div>
      <div class="dashboard-grid">
        <div class="chart-block chart-block--full">
          <div class="chart-inner-card">
            <div class="chart-body" v-if="showGraph && lineChartByWeek">
              <highcharts :options="lineChartByWeek"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>

        <div class="chart-block chart-block--half">
          <div class="chart-inner-card">
            <div class="chart-body" v-if="showGraph && columnChartByFarm">
              <highcharts :options="columnChartByFarm"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>

        <div class="chart-block chart-block--half">
          <div class="chart-inner-card">
            <div class="chart-body" v-if="showGraph && columnChartByType">
              <highcharts :options="columnChartByType"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>

        <div class="chart-block chart-block--full">
          <div class="chart-inner-card">
            <div class="chart-body" v-if="showGraph && columnChartByWorker">
              <highcharts :options="columnChartByWorker"></highcharts>
            </div>
            <div class="chart-empty" v-else>
              {{ $t('common_words.unavailable_data') }}
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="card-footer footer-date-at custom-opacity">
        <p class="text-muted d-flex justify-content-between mb-0">
          <small class="ml-3">{{ $t('common_words.smart_cultivo') }}</small>
          <small class="mr-3">{{ $t('common_words.last_six_months') }}</small>
        </p>
      </div>
    </card>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import { Axios } from 'src/class/Axios.js';
import exportingInit from 'highcharts/modules/exporting';
import Highcharts from 'highcharts';
import MixinCharts from 'src/util/mixinCharts';
exportingInit(Highcharts);

export default {
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      data: [],
      showGraph: false,
      lineChartByWeek: null,
      columnChartByFarm: null,
      columnChartByType: null,
      columnChartByWorker: null,
    };
  },
  mixins: [MixinCharts],
  methods: {
    getSixMonthRange() {
      const endDate = new Date();
      const startDate = new Date(endDate);
      startDate.setMonth(startDate.getMonth() - 6);

      const format = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      return {
        start_date: format(startDate),
        end_date: format(endDate),
      };
    },

    constructRequest() {
      const user = this.$store.getters['auth/user'];
      const date = this.getSixMonthRange();
      const business = user.business.filter((business) => business.id != 1);

      let request = { ...date };
      request.user_id = user.id;
      request.isDashboard = true;
      request.route = 'samaria/security';
      request.farms_ids = [];
      request.workers_ids = [];
      request.farms_list = [];
      request.workers_list = [];
      request.business = business[0];

      return request;
    },
  },

  created() {
    const request = this.constructRequest();

    Axios.postMasters(request)
      .then((response) => {
        this.data = response.data.data;

        if (!this.data || Object.keys(this.data).length === 0) {
          this.showGraph = false;
          return;
        }

        this.lineChartByWeek = this.lines(
          this.data.line_chart_by_week,
          true,
          'auto',
          false
        );

        this.columnChartByFarm = this.columns(this.data.column_chart_by_farm);
        this.columnChartByType = this.columns(this.data.column_by_type_name);
        this.columnChartByWorker = this.columns(this.data.column_by_worker);

        this.columnChartByWorker.legend = { enabled: false };

        // Alturas opcionales para uniformidad visual
        if (this.lineChartByWeek.chart) this.lineChartByWeek.chart.height = 360;
        if (this.columnChartByFarm.chart)
          this.columnChartByFarm.chart.height = 320;
        if (this.columnChartByType.chart)
          this.columnChartByType.chart.height = 320;
        if (this.columnChartByWorker.chart)
          this.columnChartByWorker.chart.height = 380;

        this.showGraph = !!this.lineChartByWeek;
      })
      .catch(() => {
        this.showGraph = false;
      });
  },
};
</script>
<style src="./dashboard_style.css"></style>
